import { WebIframeElement } from "../abstract_classes/WebIframeElement";

export class AsciidoctorIframeElement extends WebIframeElement<Window> {
  constructor(name: string, window: Window) {
    super(name, window);
  }
  add_events(): void {
    let window = this.window.document as unknown as HTMLElement;
    this.add_hover_and_add_scroll_events(this.get_event_elements(window), window);
    this.all_events_added();
  }
}
